import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette, breakpoints }) => ({
  managerGetStartedContent:{
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      fontWeight:'bold !important'
    },
    '& .managergetstartedcontent-title': {
      marginBottom:variables?.spacingF
    },
    '& .managergetstarted-content-container': {
      height:'370px',
      width:'902px',
      [breakpoints.down('sm')]: {
        width:'90vw'
      },
      [breakpoints.down('xs')]: {
        width:'unset',
        height:'unset',
        marginLeft:variables?.spacingE,
        marginRight:variables?.spacingE
      },
      display:'flex',
      boxShadow: variables?.elevation02,
      margin:'0 auto',
      backgroundColor:palette?.jet?.supportBrand02,
      borderRadius:'32px',
      '& .managergetstarted-content-side-section-1':{
        padding:variables?.spacingE,
        paddingRight:variables?.spacingG,
        paddingTop:variables?.spacingG,
        [breakpoints.down('xs')]:{
          width:'100%',
          paddingRight:variables?.spacingE
        },
        '& .get_started_button':{
          width:'270px',
          [breakpoints.down('xs')]:{
            width:'100%'
          }
        },
        '& .managergetstarted-content-side-section-1-articles': {
          [breakpoints.down('xs')]: {
            marginTop:variables?.spacingC,
            marginBottom:variables?.spacingC,
            height:'auto'
          },
          [breakpoints.down('sm')]: {
            marginTop:variables?.spacingC,
            marginBottom:variables?.spacingH,
            height:'auto'
          },
          marginTop:variables?.spacingF,
          height:'200px',
          paddingLeft:variables?.spacingNone,
          listStyle:'none',
          '& li':{
            marginBottom:variables?.spacingE,
            "& p": {
              position:'relative',
              paddingLeft:variables?.spacingF 
            },
            "& .jetFontIcon": {
              position:'absolute',
              left:variables?.spacingNone
            }
          },
          '& .article-icon': {
            color:palette?.jet?.contentBrand,
            position:'relative',
            top:`-${variables?.spacingA}`,
            marginRight:variables?.spacingC,
            display:'block',
            float:'left'
          }
        }
      },
      '& .managergetstarted-content-side-section-2':{
        '& .retina-image':{
          display:'none'
        },
        ['@media  only screen and (min-device-pixel-ratio: 2),only screen and (min-resolution: 192dpi)']:{
          '& .retina-image':{ 
            width:'380px',
            display:'block',
            marginRight:`${variables?.spacingNone}`,
          },
          '& .original-image':{
            display:'none'
          },
          '& .laptop-shadow-image': {
          
            left: `${variables?.spacingA} !important`
           }, 
        },
        position:'relative',
        [breakpoints.down('xs')]:{ 
          display:'none'
        },
       '& .laptop-shadow-image': {
        position:'absolute',
        bottom: '51px',
        left: '-36px'
       }, 
       '& img': {
          marginRight:`${variables?.spacingE}`,
          width:'360px',
          [breakpoints.down('sm')]: {
            
            marginTop: variables?.spacingE
          }
       }
      }
    },
    
  },
}));

export default useStyles;
